import { useApp } from '@/contexts/AppContext';
import { Loader2 } from 'lucide-react';
import { HomeownerAnalyticsView } from '@/components/analytics/HomeownerAnalyticsView';
import { InstallerAnalyticsView } from '@/components/analytics/InstallerAnalyticsView';

export default function History() {
  const { loading: appLoading, isInstaller, navigationScope } = useApp();

  if (appLoading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <Loader2 className="w-8 h-8 animate-spin text-wt-text-secondary" />
      </div>
    );
  }

  // Installer scoped to a property → show property-level analytics
  if (isInstaller && navigationScope.type === 'property' && navigationScope.propertyId) {
    return <HomeownerAnalyticsView />;
  }

  if (isInstaller) {
    return <InstallerAnalyticsView />;
  }

  return <HomeownerAnalyticsView />;
}
